export default __webpack_public_path__ + "assets/check.6df60581.svg";